import { isClientSide } from './system';

const getCurrentPath = () => {
  if (isClientSide()) {
    return decodeURIComponent(window.location.pathname.replace(/\+/g, ' '));
  }

  return null;
};

const getQueryParams = (url = window && window.location.href) => {
  if (!url) {
    return {};
  }

  return (/\?/.test(url) ? url.slice(url.indexOf('?') + 1) : url).split('&').reduce(
    (params, param) => {
      const newParams = { ...params };
      const keyValuePair = param.split('=');
      if (keyValuePair.length > 0) {
        const key = keyValuePair[0];
        const value = keyValuePair[1];
        newParams[key] = value ? decodeURIComponent(value.replace(/\+/g, ' ')) : '';
      }

      return newParams;
    },

    {}
  );
};

export { getCurrentPath, getQueryParams };
